<template>
    <div
        class="seldiaimg"
        :style="{
            width: computedWidth,
            height: computedHeight
        }"
    >
        <img
            src="@/assets/empty_state_2.svg"
            alt="Empty State"
            class="seldiaimg__img"
        />
        <h3 class="seldiaimg__heading">
            {{ t("components.selectDiamondHeading") }}
        </h3>
        <p class="seldiaimg__paragraph">
            {{ t("components.selectDiamondParagraph") }}
        </p>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "NoDiamondSelected",
    props: {
        width: {
            type: [Number, String],
            required: false,
            default: undefined
        },
        height: {
            type: [Number, String],
            required: false,
            default: undefined
        }
    },
    setup(props) {
        const computedWidth = computed(() =>
            props.width ? `${props.width}px` : "100%"
        );
        const computedHeight = computed(() =>
            props.height ? `${props.height}px` : "auto"
        );

        return { ...useI18n(), computedWidth, computedHeight };
    }
});
</script>

<style>
.seldiaimg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #7d7d7d;
}

.seldiaimg__heading {
    margin: 32px 0 0;
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
}

.seldiaimg__paragraph {
    margin: 6px 0 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
}
</style>
